type ClockIconSvgProps = {
  className?: string;
  color?: string;
};

export const ClockIconSvg = ({
  className,
  color = "#A8B4BD",
}: ClockIconSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_7071_905)">
      <path
        d="M0.998047 9.97457C0.998047 12.3556 1.94389 14.639 3.6275 16.3226C5.3111 18.0062 7.59457 18.9521 9.97555 18.9521C12.3565 18.9521 14.64 18.0062 16.3236 16.3226C18.0072 14.639 18.953 12.3556 18.953 9.97457C18.953 7.59359 18.0072 5.31013 16.3236 3.62652C14.64 1.94291 12.3565 0.99707 9.97555 0.99707C7.59457 0.99707 5.3111 1.94291 3.6275 3.62652C1.94389 5.31013 0.998047 7.59359 0.998047 9.97457Z"
        stroke={color}
        strokeWidth="1.995"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.97534 6.52148V9.97483L13.4845 14.0686"
        stroke={color}
        strokeWidth="1.995"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7071_905">
        <rect width="19.95" height="19.95" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
